import _ from 'lodash';

import createReducer from '../../../store/createReducer';
import {
    UPDATE_FIELD_VALUE_CFS,
    UPDATE_FORM_STATUS,
    SUBMIT_IN_PROGRESS,
    SUBMIT_SUCCESS,
    SUBMIT_ERROR,
    RESET_FORM,
    ADD_SPEAKER,
    UPDATE_SPEAKER,
    REMOVE_SPEAKER
} from '../actions/cfsActions';

const speaker = () =>
    _.cloneDeep({
        speakerName: {
            label: "Speaker's Name",
            placeholder: "Speaker's name",
            touched: false,
            value: ''
        },
        email: {
            label: 'Email Address',
            placeholder: 'Email',
            touched: false,
            value: ''
        },
        company: {
            label: 'Company',
            placeholder: 'Company',
            touched: false,
            value: ''
        },
        country: {
            label: 'Country',
            placeholder: 'Country',
            touched: false,
            value: ''
        },
        speakerBio: {
            label: 'About Speaker',
            placeholder: "Speaker's bio",
            touched: false,
            value: ''
        },
        photoLink: {
            label: "Speaker's Photo Link",
            placeholder: 'Link to downloadable photo ... http(s)://',
            touched: false,
            value: ''
        },
        id: 1
    });

function updateFormStatus(state, action) {
    return {
        ...state,
        [action.payload.fieldName]: action.payload.value
    };
}

function submitInProgress(state) {
    return {
        ...state,
        formSubmitInProgress: true
    };
}

function submitSuccess(state) {
    return {
        ...state,
        formSubmitInProgress: false,
        formSubmitted: true
    };
}

function submitError(state) {
    return {
        ...state,
        formSubmitInProgress: false,
        formFailed: true
    };
}

function updateCFSFieldValue(state, action) {
    return {
        ...state,
        fields: {
            ...state.fields,
            [action.payload.fieldName]: {
                ...state.fields[action.payload.fieldName],
                touched: true,
                value: action.payload.value
            }
        }
    };
}

function addSpeaker(state) {
    return {
        ...state,
        fields: {
            ...state.fields,
            speakers: [...state.fields.speakers, { ...speaker(), id: state.speakerIterator }]
        },
        speakerIterator: state.speakerIterator + 1
    };
}

function removeSpeaker(state, action) {
    const newSpeakers = state.fields.speakers.filter(s => s.id !== action.payload.id);
    return {
        ...state,
        fields: {
            ...state.fields,
            speakers: newSpeakers
        }
    };
}

function updateSpeaker(state, action) {
    const newSpeakers = [...state.fields.speakers];
    const matchSpeaker = newSpeakers.find(s => s.id === action.payload.id);
    matchSpeaker[action.payload.fieldName] = {
        ...matchSpeaker[action.payload.fieldName],
        touched: true,
        value: action.payload.value
    };
    return {
        ...state,
        fields: {
            ...state.fields,
            speakers: newSpeakers
        }
    };
}

export const initialState = {
    speakerIterator: 2,
    fields: {
        speakers: [speaker()],
        talkTitle: {
            label: 'Talk Title',
            placeholder: 'Talk title',
            touched: false,
            value: ''
        },
        talkSummary: {
            label: 'Talk Summary',
            placeholder: 'Talk summary',
            touched: false,
            value: ''
        },
        stream: {
            label: 'Stream',
            touched: false,
            value: ''
        },
        talkType: {
            label: 'Talk Type',
            touched: false,
            value: ''
        },
        audienceLevel: {
            label: 'Audience Level',
            touched: false,
            value: ''
        },
        liveCoding: {
            // optional
            label: 'Live Coding Included',
            touched: false,
            value: 'no'
        },
        technicalOrBusiness: {
            // optional
            label: 'Technical or Business talk',
            touched: false,
            value: 'technical'
        },
        twitterPromotion: {
            label: 'Twitter Promotion Text',
            placeholder:
                'Text for Twitter promotion of presentation. Maximum 120 characters including @OpenSlava and speaker’s name.',
            touched: false,
            value: ''
        },
        fbPromotion: {
            label: 'Facebook Promotion Text',
            placeholder: 'Text for Facebook promotion of presentation. Maximum 300 characters.',
            touched: false,
            value: ''
        },
        disclaimer: {
            label: 'yes',
            touched: false,
            value: false
        }
    },
    formFailed: false,
    formSubmitted: false,
    formSubmitInProgress: false
};

function resetForm() {
    return { ...initialState, fields: { ...initialState.fields, speakers: [speaker()] } };
}

export default createReducer(initialState, {
    [UPDATE_FIELD_VALUE_CFS]: updateCFSFieldValue,
    [UPDATE_FORM_STATUS]: updateFormStatus,
    [SUBMIT_IN_PROGRESS]: submitInProgress,
    [SUBMIT_SUCCESS]: submitSuccess,
    [SUBMIT_ERROR]: submitError,
    [RESET_FORM]: resetForm,
    [ADD_SPEAKER]: addSpeaker,
    [UPDATE_SPEAKER]: updateSpeaker,
    [REMOVE_SPEAKER]: removeSpeaker
});
